import { SortOptions } from '@awaze/mfe-common.configs.brand/dist/brand.types'

export const getSortOrderValueFromExpKey = (
  variant: string | undefined,
  optionsConfig: SortOptions,
) => {
  switch (variant) {
    case 'control':
      return 'recommended'
    case 'variant_a':
      return 'nosort'
    case 'variant_b':
      return 'reviewsdsc'
    case 'variant_c':
      return 'priceasc'
    case 'off':
      return optionsConfig.default
    default:
      return optionsConfig.default
  }
}
